import AdminForm from "../components/AdminForm";
import InfoList from "../components/InfoList";
import AdminSlide from "../components/AdminSlide";
import WashBrosUsers from "../components/WashBrosUsers";
import { useState } from "react";

export default function Admin() {
  const [refresh, setRefresh] = useState(false);
  const triggerRefresh = () => setRefresh(!refresh);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-purple-200 p-6">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl p-8">
        <h1 className="text-3xl font-bold text-center text-blue-600 mb-6">
          🛠 Panneau Admin
        </h1>

        {/* ── Gestion Wash Bros ── */}
        <div className="mb-8">
          <WashBrosUsers />
        </div>

        <hr className="my-6" />

        {/* ── News ── */}
        <div className="mb-8">
          <AdminForm onAdd={triggerRefresh} />
        </div>

        <hr className="my-6" />

        <h2 className="text-2xl font-semibold text-red-600 mb-4">
          📢 News
        </h2>

        <InfoList key={refresh} />

      <div className="max-w-5xl mx-auto bg-white rounded-xl shadow p-6">
        <AdminSlide />
      </div>
      </div>
    </div>
  );
}
